import React from 'react';
import { unregister } from './registerServiceWorker';
import registerAvaCAS from './registerAvaCAS';
import loadFonts from './loadFonts';
import injectTapEventPlugin from 'react-tap-event-plugin';

import logoPath from '../img/logo.avazanga.svg';

import deepAssign from 'deep-assign';

export default () => {
  return new Promise((resolve, reject) => {
    injectTapEventPlugin();
    unregister();
    loadFonts();
    registerAvaCAS(document).then(resolve, reject);
  });
};

export const getAppTheme = ({ theme } = { theme: {}}) => {
  const defaults = {
    theme: {
      favicon: '',
      title: 'Avazanga Application Portal',
      instance: {
        toolbarColor: 'rgba(255, 255, 255, 1)',
      },
      login: {
        logoPath,
        backgroundColor: 'rgba(255, 255, 255, 1)',
        footer: {
          text: '© 2013-2017 M2M Spectrum Networks, LLC',
        },
        banner: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          color: 'rgba(255, 255, 255, 1)',
          text: 'Welcome to Avazanga\nApplication Portal',
        },
        recoverText: 'We will send you an e-mail with the further instructions so that please go to your mailbox and follow the instructions provided.',
        recoverErrorText: 'We couldn\'t find your user, if you\'re sure you used a valid username please contact support.',
        recoverCompleteText: `Your request has been processed properly.
We have sent you an e-mail with the further instructions so that please go to your mailbox and follow the instructions provided.
Please note that the instructions sent to you are valid for 4 hours. After that time you will need to issue your request again.`,
        recoverTokenText: `Your request has been processed properly.
We have sent you an e-mail with the further instructions so that please go to your mailbox and follow the instructions provided.
Please note that the instructions sent to you are valid for 4 hours. After that time you will need to issue your request again.`,
        forgotPasswordInvalidTokenText: `You have used an invalid link or your link has expired!
Please go to the system or repeat your action to get a valid link into your mailbox.`,
        forgotPasswordCompleteText: `Your request has been processed properly.
Please login using your new password.`,
        registerText(showTerms) {
            return <span>This portal provides access to software applications for clients who have purchased Iota products and services. By clicking Continue, you agree to the Iota <span className="terms-link" onClick={showTerms}>Terms of Service, Privacy Policy</span> and the use of cookies.</span>
        },
        registerCompleteText: `Your registration request has been processed properly.
We have sent you an e-mail with the account activation instructions. Please activate your account within the next 4 hours otherwise it will be removed automatically!
Please do not forget to fully activate your account otherwise it will be removed and your work will be lost! Thank you for your cooperation and understanding.`,
        instanceURLHeader: 'To access M2M Spectrum Networks visit',
      },
    },
  };
  return deepAssign({}, defaults, { theme }).theme;
};



// WEBPACK FOOTER //
// ./src/bootstrap/index.js